import script from "./QLoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QLoginForm.vue?vue&type=script&setup=true&lang=js"

import "./QLoginForm.vue?vue&type=style&index=0&id=290f88fc&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290f88fc"]])

export default __exports__